import { useId } from 'react'
import cn from 'classnames'
import { IconCheckDefault, LogoWordmark } from '@mc/design-system'
import ProMedium from '../assets/pro-medium.svg'
import { type Plan } from '../constants'
import { CollapsiblePanel } from './CollapsiblePanel'
import classes from './DualCtaSection.module.scss'

interface PlanCardProps {
  plan: Plan
  groupName: string
  name: string
  description: string
  perks: string[]
  checked: boolean
  onSelect: (plan: Plan) => void
}

export const PlanCard = ({
  plan,
  groupName,
  name,
  description,
  perks,
  checked,
  onSelect,
}: PlanCardProps) => {
  const descriptionId = useId()

  return (
    <div
      className={cn(
        'mc-text--left mc-overflow--hidden mc-corners--md',
        classes.card,
        checked && classes.cardSelected,
      )}
    >
      <label
        className={cn(
          'd-flex flex-column mc-gap-1 mc-py-3 mc-clickable',
          classes.head,
        )}
      >
        <input
          type='radio'
          name={groupName}
          value={plan}
          checked={checked}
          onChange={() => onSelect(plan)}
          autoComplete='off'
          aria-label={name}
          aria-describedby={descriptionId}
          className='mc-sr-only'
        />
        <span className='d-flex align-items-center' aria-hidden='true'>
          <LogoWordmark className={classes.wordmark} />
          {plan === 'pro' && (
            <ProMedium className={cn(classes.wordmark, classes.proWordmark)} />
          )}
        </span>
        <span id={descriptionId} className='mc-text-x-small mc-opacity--muted'>
          {description}
        </span>
      </label>
      <CollapsiblePanel isOpen={checked}>
        <ul
          className={cn(
            'mc-mb-0 d-flex flex-column mc-gap-2 mc-opacity--hinted',
            classes.perks,
          )}
        >
          {perks.map((perk, index) => (
            <li
              key={index}
              className='d-flex align-items-start mc-gap-2 mc-text-x-small'
            >
              <IconCheckDefault
                className={cn('flex-shrink-0', classes.perkIcon)}
              />
              <span>{perk}</span>
            </li>
          ))}
        </ul>
      </CollapsiblePanel>
    </div>
  )
}
